import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import MoneyMindUsersTable from './MoneyMindUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyMoneyMindUsers } from './companyMoneyMindApi';

/**
 * Company MoneyMind → Employees/Members list.
 * Every user of the current population appears (those who have never logged
 * anything show dashes and sort last); a row opens their usage profile.
 */
const CMoneyMindUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyMoneyMindUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>MoneyMind — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and how often they use MoneyMind. Open a user
        to see their usage — never what they spend or what they bought.
      </p>

      <MoneyMindUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/moneymind/user?userId=${rowData?._id}`)}
        tableName="company_moneymind_users"
      />
    </div>
  );
};

export default CMoneyMindUsers;
